import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { IsinDataDialogModel } from 'src/app/models/dialogs-models/isin-data-dialog-model';
import { Helpers } from 'src/app/models/Helpers/helpers';

@Component({
  selector: 'app-update-portfolio-isin-dialog',
  templateUrl: './update-portfolio-isin-dialog.component.html',
  styleUrls: ['./update-portfolio-isin-dialog.component.scss']
})
export class UpdatePortfolioIsinDialogComponent implements OnInit {

  form: FormGroup;
  PRICE_FORMAT_REGEX = '^\\d+(\\.\\d+)?$';

  constructor(
    private formBuilder: FormBuilder,
    public dialogRef: MatDialogRef<any>,
    @Inject(MAT_DIALOG_DATA) public isinData: IsinDataDialogModel
  ) { }

  ngOnInit(): void {
    this.form = this.formBuilder.group({
      amount: [this.isinData.qta, [
        Validators.required
      ]],
      price: this.formBuilder.control(
        this.isinData.prezzo,
        {
          validators: [
            Validators.required,
            Validators.pattern(this.PRICE_FORMAT_REGEX)
          ],
          updateOn: 'blur'
        }
      ),
      date: [this.isinData.dataInserimento, [
        Validators.required
      ]],
    });
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  onYesClick(): void {
    const data: IsinDataDialogModel = {
      id: this.isinData.id,
      isin: this.isinData.isin,
      qta: Number(this.form.value.amount),
      prezzo: Number(this.form.value.price),
      dataInserimento: Helpers.convertDateToLocalFormat(this.form.value.date),
      watchid: this.isinData.watchid
    };
    this.dialogRef.close(data);
  }

  public isValidPrice = () => {
    return parseFloat(this.form.get('price').value) > 0;
  }
}
